import { render } from "./HomeResume.vue?vue&type=template&id=637f56bb&scoped=true"
import script from "./HomeResume.vue?vue&type=script&lang=js"
export * from "./HomeResume.vue?vue&type=script&lang=js"

import "./HomeResume.vue?vue&type=style&index=0&id=637f56bb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637f56bb"]])

export default __exports__